enum ToolbarContextEnum {
  Clear = "_clear",
  Library = "_library",
  ViewItem = "_viewItem",
  EditItem = "_editItem",
  CreateItem = "_createItem",
}

export default ToolbarContextEnum;
